import { removeDuplicates } from '../helpers';
import { getRuntimeFontFamily } from 'components/graphicEditor/services/FontsService';

export function normalizeFontWithPrefix(font, idPrefix, isCustom) {
  const fallbackFamily = getRuntimeFontFamily(font);
  const fallbackId =
    font.id ??
    `${idPrefix}-${(fallbackFamily || font.name || 'font').replace(/[^a-zA-Z0-9_-]/g, '_').slice(0, 50)}`;
  return {
    ...font,
    id: fallbackId,
    family: fallbackFamily,
    isCustom,
  };
}

export function normalizeDesignFontEntry(font) {
  const fallbackFamily = getRuntimeFontFamily(font);
  const fallbackId =
    font.id ??
    `design-${(fallbackFamily || font.name || 'font').replace(/[^a-zA-Z0-9_-]/g, '_').slice(0, 50)}`;
  return {
    ...font,
    id: fallbackId,
    family: fallbackFamily,
    isCustom: true,
  };
}

/**
 * Merges API payload (uploaded + default) with design fonts; dedupes by removeDuplicates helper.
 * @param {{ uploaded_fonts?: array, default_fonts?: array }|null|undefined} data
 * @param {array} designFonts
 */
export function mergeFontsFromOrganizationApi(data, designFonts = []) {
  if (!data) return null;

  const mergedFonts = [
    ...(data.uploaded_fonts || []).map((font) =>
      normalizeFontWithPrefix(font, 'uploaded', true),
    ),
    ...(data.default_fonts || []).map((font) =>
      normalizeFontWithPrefix(font, 'default', false),
    ),
    ...designFonts.map((font) =>
      normalizeFontWithPrefix(font, 'design', true),
    ),
  ];

  return removeDuplicates(mergedFonts);
}

/**
 * @param {array} designFonts raw from design JSON
 * @param {array} currentFonts current merged `fonts` from app state
 */
export function mergeDesignFontsIntoFontsList(designFonts, currentFonts) {
  const newDesignFonts = designFonts.map(normalizeDesignFontEntry);
  return removeDuplicates([...currentFonts, ...newDesignFonts]);
}
